<template>
  <v-app class="auth-page auth-page--neutral">
    <v-container fluid class="auth-split__panel pa-0">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="5">
          <v-card class="auth-card auth-card--centered" elevation="0">
            <v-card-text class="auth-card__body text-center">
              <v-icon color="success" size="72" class="mb-4">mdi-check-circle-outline</v-icon>

              <h1 class="auth-card__title mb-2">Solicitação enviada</h1>
              <p class="auth-card__subtitle mb-4">
                Sua solicitação de cancelamento foi enviada com sucesso!
              </p>

              <v-alert type="info" outlined dense class="mb-4 text-left">
                <div>
                  <strong>O que acontece agora?</strong>
                  <ul class="mt-2 mb-0 auth-list">
                    <li>Sua solicitação será analisada pela nossa equipe</li>
                    <li>Nossa equipe entrará em contato com você para mais informações</li>
                    <li>Após a análise, sua conta será desativada</li>
                  </ul>
                </div>
              </v-alert>

              <v-btn color="primary" dark depressed large block @click="goToLogin">
                <v-icon left>mdi-login</v-icon>
                Voltar para login
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  methods: {
    goToLogin() {
      this.$router.push("/login");
    },
  },
});
</script>

<style scoped lang="scss">
.auth-card--centered .auth-card__body {
  padding-top: 32px !important;
}

.auth-list {
  padding-left: 20px;

  li {
    margin-bottom: 8px;
  }
}
</style>
